import { Button, Col, Form, FormInstance, Input, InputNumber, Modal, Row } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { VALIDATION_MESSAGE_CONFIG } from "../../../../../../constants/constants";
import { ResourcesModel } from "../../../../../../models/resources.model";
import { ControlEffectivenessesModel } from "../../../../../../models/scenario-mitigation.model";
import { VALIDATION_UTIL } from "../../../../../../utils/validation.utils";
import { InfoCircleIcon } from "../../../../../atoms/icon";
import PercentInput from "../../../../../atoms/percent-input";
import { AppSelect } from "../../../../../atoms/select";

interface Props {
    visible?: boolean;
    data?: ControlEffectivenessesModel;
    onOK: (data: ControlEffectivenessesModel) => void;
    onCancle: () => void;
    loading?: boolean;
    requiredFields?: string [];
    resources?: ResourcesModel;
}

const ControlEffectivenessModal: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const formRef = useRef<FormInstance<any>>(null);

    const onOk = () => {
        formRef.current?.submit();
    };

    const submit = () => {
        const values = formRef.current?.getFieldsValue();
        props.onOK(values);
    }

    useEffect(() => {
        formRef.current?.resetFields();
        if (props.data) {
            formRef.current?.setFieldsValue(props.data);
        }
    }, [props.data, formRef])

    return (
        <Modal
            className="control-effec-modal"
            title={props.data && props.data.id ? t("ScenarioMitigation.lbEditEntry") : t("ScenarioMitigation.lbNewEntry")}
            visible={props.visible}
            onCancel={props.onCancle}
            footer={<Button htmlType="submit" type="primary" shape="round" onClick={onOk} loading={props.loading}>
                {props.data && props.data.id ? t("ScenarioMitigation.btnModalSave") : t("ScenarioMitigation.btnSaveAdd")}
            </Button>}
        >
            <Form
                layout="vertical"
                className="modal-form"
                onFinish={submit}
                ref={formRef}
                validateMessages={VALIDATION_MESSAGE_CONFIG}>
                <Form.Item
                    name="id"
                    hidden>
                    <Input />
                </Form.Item>
                <Form.Item
                    name="control_name"
                    label={t("ScenarioMitigation.lbControlName")}
                    tooltip={{ title: t("ScenarioMitigation.lbControlName"), icon: <InfoCircleIcon /> }}
                    rules={VALIDATION_UTIL.getRulesValidationField("control_name", props.requiredFields)}
                    >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="description_of_control"
                    label={t("ScenarioMitigation.lbDescriptionOfControl")}
                    rules={VALIDATION_UTIL.getRulesValidationField("description_of_control", props.requiredFields)}
                >
                    <TextArea rows={5} placeholder={t("ScenarioMitigation.plAdditionalNotes")} />
                </Form.Item>

                <Row gutter={16}>
                    <Col span={12}>
                        <AppSelect
                            name="control_type_id"
                            label={t("ScenarioMitigation.lbControlType")}
                            tooltip={{ title: t("ScenarioMitigation.lbControlType"), icon: <InfoCircleIcon /> }}
                            list={props.resources?.scenario_mitigation_resources?.control_effectiveness_control_types}
                            rules={VALIDATION_UTIL.getRulesValidationField("control_type_id", props.requiredFields)} />
                    </Col>
                    <Col span={12}>
                        <AppSelect
                            name="status_id"
                            label={t("ScenarioMitigation.lbStatus")}
                            tooltip={{ title: t("ScenarioMitigation.lbStatus"), icon: <InfoCircleIcon /> }}
                            list={props.resources?.scenario_mitigation_resources?.control_effectiveness_control_statuses}
                            rules={VALIDATION_UTIL.getRulesValidationField("status_id", props.requiredFields)} />
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="weight_percent"
                            label={t("ScenarioMitigation.lbWeight")}
                            tooltip={{ title: t("ScenarioMitigation.lbWeight"), icon: <InfoCircleIcon /> }}
                            rules={VALIDATION_UTIL.getRulesValidationField("weight", props.requiredFields)}
                        >
                            <PercentInput />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="effectiveness_value"
                            label={t("ScenarioMitigation.lbEffectivenessValue")}
                            tooltip={{ title: t("ScenarioMitigation.lbEffectivenessValue"), icon: <InfoCircleIcon /> }}
                            rules={VALIDATION_UTIL.getRulesValidationField("effectiveness_value", props.requiredFields)}
                        >
                            <InputNumber min={0} max={24} placeholder="0 - 24" />
                        </Form.Item>
                    </Col>
                </Row>

                {/* <Row gutter={[16, 32]} className="modal-total-text">
                    <Col span={16} className="total-text">
                        {t("ScenarioMitigation.ttOverallValue")}
                    </Col>
                    <Col span={8}>
                        {props.data?.overall_value}
                    </Col>
                </Row> */}
            </Form>
        </Modal>

    );
};

export default ControlEffectivenessModal;